import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
    var sendbtn = document.querySelector('#sendbtn');
  sendbtn.addEventListener('click', enviarMensaje)

  
  function enviarMensaje(){
    let inputName = (document.querySelector('#formGroupExampleInput')as HTMLTextAreaElement).value;
    let textareame = (document.querySelector('#exampleFormControlTextarea1')as HTMLTextAreaElement).value;
    let url = "https://api.whatsapp.com/send?phone=522381459899&text=Nombre: %0A" + inputName + "%0A%0AMensaje: %0A" + textareame + "%0A"; 
    window.open(url);

        
  }
  }

}
